import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { SpinnerComponent } from './spinner/spinner.component';
import { MaterialModule } from './material.module';
import { AngularFireStorageModule } from '@angular/fire/storage';
import { ImageCarouselComponent } from './image-carousel/image-carousel.component';

@NgModule({
  declarations: [SpinnerComponent, ImageCarouselComponent],
  imports: [
    CommonModule,
    MaterialModule,
    FormsModule,
    ReactiveFormsModule,
    AngularFireStorageModule
  ],
  exports: [
    SpinnerComponent,
    ReactiveFormsModule,
    FormsModule,
    MaterialModule,
    ImageCarouselComponent
  ]
})
export class SharedModule {}
